export default __webpack_public_path__ + "static/media/close-btn.e279f091.svg";